import type { Dispatch, FunctionComponent, SetStateAction } from 'react'
import type { ShowToastOptions } from '@ztechapps/common.hook'
import type { IToastAction } from './IToastAction'
import type { Class } from 'type-fest'
import ReactToastify from './ReactToastify'
//import BootstrapToast from './BootstrapToast'

export type ToasterProps = {
  showToastOptions: ShowToastOptions
  setShowToastOptions: Dispatch<SetStateAction<ShowToastOptions>>
}
export type Toaster = {
  toaster: FunctionComponent<ToasterProps>
  toastAction: Class<IToastAction>
}
export type ToastComponent = {
  toaster: Toaster
}

export const defaultComponent: ToastComponent = {
  toaster: ReactToastify,
  //toaster: BootstrapToast,
}
